import { queryOptions } from "@tanstack/react-query";
import { GET_FUKADA_EVENT_CAMPAIGN_SCHEDULE } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type {
  FukadaCampaignSchedule,
  GetFukadaEventCampaignScheduleResponse,
} from "~/types/fukadaCampaign";
import { parseJstDateTime } from "~/utils/jstDate";

const EMPTY_SCHEDULE: FukadaCampaignSchedule = {
  fukadaUserId: "",
  ongoingVersion: null,
  nextVersion: null,
  tiers: [],
};

/**
 * 深田えいみキャンペーンの全段スケジュール（dailyBonus / live 双方の feature から参照する共有クエリ）。
 * BE は JST の 'yyyyMMddHHmmss' 文字列を返すため、ここで Date に変換して公開する。
 */
export const fukadaCampaignScheduleQueryOptions = queryOptions({
  queryKey: queryKeys.fukadaCampaign.schedule(),
  queryFn: async (): Promise<FukadaCampaignSchedule> => {
    const res = await apiClient<GetFukadaEventCampaignScheduleResponse>(
      GET_FUKADA_EVENT_CAMPAIGN_SCHEDULE,
    );
    // apiClient は 502 を成功扱いにし data:[] を返すため配列は非開催として扱う
    if (Array.isArray(res)) {
      return EMPTY_SCHEDULE;
    }
    return {
      fukadaUserId: res.fukada_user_id,
      ongoingVersion: res.ongoing_version,
      nextVersion: res.next_version,
      tiers: res.schedules.map((tier) => ({
        version: tier.version,
        campaignStart: parseJstDateTime(tier.campaign_start),
        campaignEnd: parseJstDateTime(tier.campaign_end),
        liveStart: parseJstDateTime(tier.live_start),
        liveEnd: parseJstDateTime(tier.live_end),
      })),
    };
  },
  staleTime: 5 * 60 * 1000,
});
